import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface ICallCodeModel extends IModel {
  callCodeId: number;
  name: string;
  isSystemGenerated: boolean;
}

export class CallCodeModel
  extends Model
  implements ModelRecord<ICallCodeModel>
{
  callCodeId: number;
  name: string;
  isSystemGenerated: boolean;

  constructor(params?: Partial<ICallCodeModel>) {
    super(params);

    this.callCodeId = defaultTo(params?.callCodeId, 0);
    this.name = defaultTo(params?.name, '');
    this.isSystemGenerated = defaultTo(params?.isSystemGenerated, false);
  }
}
